import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { promptInstall, onInstallPromptReady } from './index';
import { useTranslation } from 'react-i18next';

import Home from './containers/Home';
import Srtapp from './containers/Srtapp';
import CambiarPassword from './containers/CambiarPassword';
import NewUser from './components/srtapp/modals/NewUser';
import ChangeEmail from './components/srtapp/modals/ChangeEmail';
import Maintenance from './containers/Maintenance';
import Unavailable from './containers/Unavailable';
import DownloadPage from './containers/DownloadPage';

function App() {
  const { t } = useTranslation();
  const [showInstall, setShowInstall] = useState(false);
  const [isIos, setIsIos] = useState(false);
  const [isFirefox, setIsFirefox] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const location = useLocation();
  const isInicio = location.pathname === '/inicio';

  const DISMISS_DAYS = 7;

  // Detecta iOS
  const detectIos = () => /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
  // Detecta Firefox
  const detectFirefox = () => /firefox/i.test(window.navigator.userAgent);
  // Detecta si la app ya está instalada
  const detectStandalone = () => {
    return (
      (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
      ('standalone' in window.navigator && window.navigator.standalone)
    );
  };

  // Comprueba si el usuario rechazó recientemente la instalación
  const wasDismissedRecently = () => {
    const dismissedAt = localStorage.getItem('pwaInstallDismissedAt');
    if (!dismissedAt) return false;
    const daysSince = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60 * 24);
    return daysSince < DISMISS_DAYS;
  };

  const dismissInstallMessages = () => {
    localStorage.setItem('pwaInstallDismissedAt', Date.now().toString());
    setShowInstall(false);
  };

  useEffect(() => {
    setIsIos(detectIos());
    setIsFirefox(detectFirefox());
    setIsStandalone(detectStandalone());

    // Si ya instalada o recientemente descartada → no mostrar
    if (detectStandalone() || wasDismissedRecently()) {
      setShowInstall(false);
      return;
    }

    // Escucha cuando se instala (Chrome/Edge)
    window.addEventListener('appinstalled', () => {
      setShowInstall(false);
    });

    const isNowIos = detectIos();
    const isNowFirefox = detectFirefox();

    if (isNowIos || isNowFirefox) {
      // En iOS y Firefox mostramos siempre si no está rechazado
      setShowInstall(true);
    } else {
      // En Chrome/Edge esperamos al beforeinstallprompt
      onInstallPromptReady(() => {
        setShowInstall(true);
      });
    }
  }, []);

  return (
    <div className='App'>
      {/* Botón Chrome/Edge */}
      {isInicio && !isStandalone && !isIos && !isFirefox && showInstall && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
          }}
        >
          <button
            id='installButton'
            style={{
              padding: '10px 15px',
              background: '#0066cc',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
              marginBottom: '5px'
            }}
            onClick={async () => {
              const outcome = await promptInstall();
              console.log('Instalación: ', outcome);
              if (outcome !== 'accepted') dismissInstallMessages();
              else setShowInstall(false);
            }}
          >
            {t('instalarapp')}
          </button>
          <button
            onClick={dismissInstallMessages}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#999',
              fontSize: '12px',
              cursor: 'pointer'
            }}
          >
            {t('cerrar')}
          </button>
        </div>
      )}

      {/* Instrucciones iOS */}
      {isInicio && isIos && !isStandalone && showInstall && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            right: '20px',
            zIndex: 9999,
            background: '#f8f9fa',
            border: '1px solid #ccc',
            padding: '10px',
            borderRadius: '8px',
            textAlign: 'center'
          }}
        >
          {t('instalarappios')}
          <button
            onClick={dismissInstallMessages}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#999',
              fontSize: '12px',
              marginTop: '5px',
              cursor: 'pointer'
            }}
          >
            {t('cerrar')}
          </button>
        </div>
      )}

      {/* Fallback Firefox */}
      {isInicio && isFirefox && !isStandalone && showInstall && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            right: '20px',
            zIndex: 9999,
            background: '#f8f9fa',
            border: '1px solid #ccc',
            padding: '10px',
            borderRadius: '8px',
            textAlign: 'center'
          }}
        >
          {t('instalarappfox')}
          <button
            onClick={dismissInstallMessages}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#999',
              fontSize: '12px',
              marginTop: '5px',
              cursor: 'pointer'
            }}
          >
            {t('cerrar')}
          </button>
        </div>
      )}

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/inicio' element={<Srtapp />} />
        <Route path='/passwordreset/:token/edit' element={<CambiarPassword />} />
        <Route path='/urlaccountactiv/:token/edit' element={<NewUser />} />
        <Route path='/emailchange/:token/edit' element={<ChangeEmail />} />
        <Route path='/maintenance' element={<Maintenance />} />
        <Route path='/unavailable' element={<Unavailable />} />
        <Route path="/download" element={<DownloadPage />} />
      </Routes>
    </div>
  );
}

export default App;
